import randomColor from 'randomcolor';

export const getColorByLetters = (
  letters: string,
  luminosity?: 'bright' | 'light' | 'dark' | 'random',
) => {
  return randomColor({
    luminosity,
    seed: letters,
  });
};
